export default __webpack_public_path__ + "static/media/artificial-intelligence.3acadca2.svg";